<template>
  <div class="slider">
    <label>
      {{ label }}
    </label>
    <input
      class="sliderInput"
      type="range"
      min="0"
      :max="max"
      :value="value"
      @change="handleChange"
      @input="handleChange"
    />
  </div>
</template>

<script>
  let slider = {
    name: 'Slider',
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: Number,
        default: 0,
        watch: function(value) {
          this.localValue = value;
        }
      },
      max: {
        type: Number,
        default: 10
      },
    },
    methods: {
      /**
       * Handles a value change in the slider.
       * 
       * @listens onchange, input
       */
      handleChange: function(e) {
        /**
         * Value change event for this component.
         * 
         * @type {number}
         */
        this.$emit('slider-change', parseInt(e.target.value));
      },
    }
  };
  export default slider;
</script>

<style lang="scss" scope>
@use 'sass:math';
$sliderSize: 15px;
$trackHeight: 2px;
$trackColor: #DDDDDD;

.slider {
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  label {
    flex-shrink: 0;
    width: 15%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    font-family: var(--font-family);
    font-weight: bold;
    font-size: 12px;
    color: #757575;
    letter-spacing: unset;
  }

  input[type=range] {
    /* Hide the slider so custom styles can be added */
    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
    flex-grow: 1; /* Specific width is required for Firefox. */
    background: transparent; /* Otherwise white in Chrome */

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
    }
    &:focus {
      outline: none; /* Removes the blue border */
    }
    &::-ms-track {
      width: 100%;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }

    /* Style the circle */
    // Special styling for WebKit/Blink
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: $sliderSize;
      width: $sliderSize;
      border-radius: 50%;
      background: var(--default-color);
      cursor: pointer;
      margin-top: -((math.div($sliderSize, 2)) - (math.div($trackHeight, 2)));
    }
    // All the same stuff for Firefox
    &::-moz-range-thumb {
      height: $sliderSize;
      width: $sliderSize;
      border-radius: 50%;
      background: var(--default-color);
      cursor: pointer;
    }
    // All the same stuff for IE
    &::-ms-thumb {
      height: $sliderSize;
      width: $sliderSize;
      border-radius: 50%;
      background: var(--default-color);
      cursor: pointer;
    }

    /* Style the track */
    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 2px;
      cursor: pointer;
      background: $trackColor;
      border-radius: 1.3px;
    }
    &:focus::-webkit-slider-runnable-track {
      background: var(--default-color);
    }
    &::-moz-range-track {
      width: 100%;
      height: $trackHeight;
      cursor: pointer;
      background: $trackColor;
      border-radius: 1.3px;
    }
    &::-ms-track {
      width: 100%;
      height: $trackHeight;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      border-width: 16px 0;
      color: transparent;
    }
    &::-ms-fill-lower {
      background: $trackColor;
      border-radius: 2.6px;
    }
    &:focus::-ms-fill-lower {
      background: var(--default-color);
    }
    &::-ms-fill-upper {
      background: $trackColor;
      border-radius: 2.6px;
    }
    &:focus::-ms-fill-upper {
      background: var(--default-color);
    }
  }
}
</style>
